import React from 'react';
import { Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { formatToLocalDateTime } from '../../../utils/dateFormatter';
import EditIcon from '@mui/icons-material/Edit';
import { removeZeroDecimals } from '../../../utils/removeZeroDecimals';
import { getTempLevel } from '../../../utils/getTempLevel';
import { getPulseLevel } from '../../../utils/getPulseLevel';
import { getRespiratoryLevel } from '../../../utils/getRespiratoryLevel';
import RequirePermission from '../../RequirePermission';
import { SUB_MODULES } from '../../../constants/subModulesConstants';

export default function VitalsView({handleEdit, open, onClose, vitals = null}) { 

    const handleClose = () => {
        onClose();
    };

    const handleEditClick = () => {
        handleEdit(vitals);
    };

    if (!vitals) {
        return (
            <></>
        );
    }

    return (
        <React.Fragment>
        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            
            <DialogTitle>Vitals</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Patient</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{`${vitals.pet.name} (${vitals.pet.owner.last_name}, ${vitals.pet.owner.first_name})`}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Body Weight (kg)</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{vitals.weight || "(none)"}</Typography>
                
                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Temperature (&deg;C)</Typography>
                <Typography variant="body1" color={vitals.temp ? getTempLevel(vitals.temp, vitals.pet.species_id) : null}  sx={{ mt: 0 }}>{vitals.temp? removeZeroDecimals(vitals.temp) : "(none)"}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Pulse Rate</Typography>
                <Typography variant="body1" color={vitals.pulse ? getPulseLevel(vitals.pulse, vitals.pet.species_id, vitals.weight, vitals.pet.birthdate) : null} sx={{ mt: 0 }}>{vitals.pulse ? removeZeroDecimals(vitals.pulse) : "(none)"}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Respiration Rate</Typography>
                <Typography variant="body1" color={vitals.respiration > 0 ? getRespiratoryLevel(vitals.respiration, vitals.pet.species_id) : null} sx={{ mt: 0 }}>{vitals.respiration > 0 ? removeZeroDecimals(vitals.respiration) : "(none)"}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Mucous Membrane Color</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{vitals.mmc || "(none)"}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Capillary Refill Time</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{vitals.crt || "(none)"}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Pain Score</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{vitals.pain || "(none)"}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Mentation</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{vitals.mentation || "(none)"}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Created</Typography>
                <Typography variant="body2" sx={{ mt: 0 }}>{formatToLocalDateTime(vitals.createdAt)}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Last Updated</Typography>
                <Typography variant="body2" sx={{ mt: 0 }}>{formatToLocalDateTime(vitals.updatedAt)}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>User</Typography>
                <Typography variant="body2" sx={{ mt: 0 }}>{vitals.user.name}</Typography>

            </DialogContent>
            <DialogActions>
              <RequirePermission subModuleName={SUB_MODULES.VITALS} minAccessLevel={2}>
                <Button onClick={handleEditClick}>
                  <EditIcon />
                </Button>
              </RequirePermission>
                <div style={{flex: '1 0 0'}} />
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}